// Libraries
import { Grid } from "@mui/material";

// Utils
import { or } from "@/Common/helpers/sonar";

// Components
import SearchInput from "@Layouts/components/Basics/SearchInput";

type TGlobalSearchProps = {
	loading: boolean;
	isDataPresent: boolean;
	value: string;
	onChangeValue: (value: string) => void;
	onClearSearch: () => void;
};

export default function GlobalSearch(props: Readonly<TGlobalSearchProps>) {
	const { loading, isDataPresent, value, onChangeValue, onClearSearch } = props;

	const display = or(loading, isDataPresent) ? "flex" : "none";

	return (
		<Grid container mt={1} justifyContent={"flex-end"} sx={{ display }} className="!mt-[16px]">
			<Grid item xs={3}>
				<SearchInput value={value} loading={loading} sx={{ display }} onChange={onChangeValue} clearSearch={onClearSearch} />
			</Grid>
		</Grid>
	);
}
